import cn from "classnames";
import { Link } from "gatsby";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import Icon from "components/Icon";
import Search from "components/Search";

import "styles/index.css";
import * as styles from "./Layout.module.scss";


const Layout = ({ breadcrumb, children }) => {
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    if (searchOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }, [searchOpen]);

  return (<>
    <Helmet>
      <style>{`
        :root{
          --font-name: ${process.env.GOOGLE_FONT_NAME};
        }
      `}</style>
    </Helmet>

    <header className={cn(styles.header, {
      [styles[`headerSearchOpen`]]: searchOpen,
    })}>
      <Link to="/" className={styles.title}>{process.env.SITE_TITLE}</Link>
      {/* {breadcrumb && ` / ${breadcrumb}`} */}
      <button onClick={() => setSearchOpen(s => !s)} className={styles.button}>
        <Icon icon="search" />
      </button>
      <Search open={searchOpen} onClose={setSearchOpen} />
    </header>
    <div className={styles.line} />
    <div className={styles.inner} />
    <div className={styles.el}>
      {children}
    </div>
  </>);
};

export default Layout;


const Footer = ({
  className,
}) => {

  return (
    <footer className={cn(styles.footer, className)}>
      <Link to="/archive" className={styles.archive}>
        <Icon icon="inventory_2" />
        Browse the archive
      </Link>
    </footer>
  );
};

export { Footer };
